import { ApiResponse } from '@ace/core';

import { EndpointCallParams } from '@core/api/endpointCallParams';
import { IApiStore } from '@core/api/apiStore';

export type UploadProcedureImageParams = {
    id: string;
    file: File;
};

export const performUploadProcedureImage = async (
    api: IApiStore,
    params: EndpointCallParams<UploadProcedureImageParams>,
    progressHandler?: (percent: number) => void,
): Promise<ApiResponse> => {
    const { payload, ...rest } = params;
    const { file, id } = payload;

    const req = await api
        .putAFile(
            `contentfileprovider-app/api/v1/FileProvider/procedurepreview/${id}`,
            {
                ...rest,
                payload,
                progressHandler,
            },
            { fileField: 'file', file },
            {},
        );

    return req;
};
